// TODO: Refactor/clean up this legacy scroll tracker. Should we refactor this as a component level hook instead?
(function(scrollTracker) {
  var defaultOptions = {
    trackDelay: 1500,
    percentInterval: 10
  };

  var lastScroll = null;
  scrollTracker.value = 0;
  var eventSent = false;

  function _gaLt(event) {
    var el = event.srcElement || event.target;

    /* Loop up the tree through parent elements if clicked element is not a link (eg: an image inside a link) */
    while (el && (typeof el.tagName == "undefined" || el.tagName.toLowerCase() != "a" || !el.href)) el = el.parentNode;

    if (el && el.href && !el.href.match("/_") && el.href !== "/" && (" " + el.className + " ").indexOf(" skip-scroll-tracker ") == -1) {
      sendTheEvent();

      /* if target not set then delay opening of window by 0.5s to allow tracking */
      if (!el.target || el.target.match(/^_(self|parent|top)$/i)) {
        setTimeout(
          function() {
            document.location.href = el.href;
          }.bind(el),
          500
        );

        /* Prevent standard click */

        event.preventDefault ? event.preventDefault() : (event.returnValue = !1);
      }
    }
  }

  function sendTheEvent() {
    if (!eventSent && window.gtag) {
      window.gtag("send", "event", {
        event_category: "Scroll Tracker",
        event_action: "Scrolling Percentage",
        event_label: scrollTracker.value + "",
        value: scrollTracker.value,
        transport: "beacon"
      });

      if (window.afClientId == "50002" && window.gtag) {
        window.gtag("tf.send", "event", {
          event_category: "Scroll Tracker",
          event_action: "Scrolling Percentage",
          event_label: scrollTracker.value + "",
          value: scrollTracker.value,
          transport: "beacon"
        });
      }

      eventSent = true;
    }
  }

  scrollTracker.init = function() {
    /* Attach the event to all clicks in the document after page has loaded */

    var w = window;

    w.addEventListener
      ? w.addEventListener(
          "load",
          function() {
            document.body.addEventListener("click", _gaLt, !1);
          },
          !1
        )
      : w.attachEvent &&
        w.attachEvent("onload", function() {
          document.body.attachEvent("onclick", _gaLt);
        });

    window.onbeforeunload = function() {
      sendTheEvent();
    };
  };

  scrollTracker.init();

  function scrollPercent() {
    return Math.ceil(((scrollPosition() + viewportHeight()) / pageHeight()) * 100);
  }

  function pageHeight() {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,

      document.body.offsetHeight,
      document.documentElement.offsetHeight,

      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  }

  function viewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName("body")[0].clientHeight || 0;
  }

  function scrollPosition() {
    return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
  }

  function scrollPercentByInterval(percentInterval) {
    var multiplier = parseInt(scrollPercent() / (parseInt(percentInterval) - 0.0000000001));
    return multiplier * parseInt(percentInterval);
  }

  scrollTracker.getPercent = function() {
    return scrollPercentByInterval(defaultOptions.percentInterval);
  };

  function processScroll() {
    if (lastScroll === null || new Date().getTime() - lastScroll >= parseInt(defaultOptions.trackDelay)) {
      var currentPostion = scrollPercentByInterval(defaultOptions.percentInterval);
      //console.log(currentPostion);
      if (currentPostion > scrollTracker.value) scrollTracker.value = currentPostion;
    }
  }

  window.onscroll = throttle(function() {
    lastScroll = new Date().getTime();
    setTimeout(processScroll, parseInt(defaultOptions.trackDelay) + 25);
  }, 100);

  function throttle(func, wait) {
    var context, args, result;
    var timeout = null;
    var previous = 0;

    var later = function() {
      previous = new Date();
      timeout = null;
      result = func.apply(context, args);
    };

    return function() {
      var now = new Date();
      if (!previous) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;

      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  }
})((window.scrollTracker = window.scrollTracker || {}));
